import * as React from 'react'

import { InfiniteScroll } from '@factorialco/deprecated-design-system'
import cn from 'classnames/bind'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import type { Collection } from 'modules/core/lib/mobx-rest'
import type { Model } from 'modules/core/lib/mobx-rest'

import styles from './index.module.css'

const cx = cn.bind(styles)

const DefaultLoader = () => (
  <div key="infiniteLoader">
    <Loading />
  </div>
)

export type ListSizeType = 'big' | 'small'
interface ContainerProps {
  useContainerWrapper: boolean
  listSize?: ListSizeType
}

const Container = ({
  useContainerWrapper,
  children,
  listSize,
}: React.PropsWithChildren<ContainerProps>) => {
  if (!useContainerWrapper) return <>{children}</>

  return <div className={cx('infiniteScroll', listSize)}>{children}</div>
}

export interface RenderProps<T extends Model> {
  items: T[] | Collection<T>
}
interface Props<T extends Model> {
  element?: 'div' | 'tbody'
  items: T[] | Collection<T>
  initialBatchSize: number
  listSize?: ListSizeType
  loader?: React.ReactNode
  nakedItem?: boolean
  useContainerWrapper?: boolean
}

const InfiniteScrollerList = <T extends Model>({
  items,
  element = 'div',
  initialBatchSize,
  listSize,
  loader,
  nakedItem,
  useContainerWrapper,
  children,
}: Props<T> & React.ConsumerProps<RenderProps<T>>) => {
  const [page, setPage] = React.useState(1)
  const [hasMore, setHasMore] = React.useState(items.length > initialBatchSize)

  const loadMore = (page: number) => {
    setPage(page)
    setHasMore(items.length > initialBatchSize * page)
  }

  const itemsToShow = () => {
    return items.slice(0, initialBatchSize * page)
  }

  const Loader = () => {
    if (!loader) return <DefaultLoader />

    return <>{loader}</>
  }

  return (
    <Container useContainerWrapper={!!useContainerWrapper} listSize={listSize}>
      <InfiniteScroll
        element={element}
        pageStart={page}
        loadMore={loadMore}
        hasMore={hasMore}
        useWindow={false}
        loader={<Loader />}
      >
        {nakedItem &&
          children({
            items: itemsToShow(),
          })}
        {!nakedItem && (
          <div className={styles.list}>
            {children({
              items: itemsToShow(),
            })}
          </div>
        )}
      </InfiniteScroll>
    </Container>
  )
}

export default observer(InfiniteScrollerList)
